module.exports = __webpack_public_path__ + "img/logoForQrSmall.8f2e7d8b.png";